import { trpc } from "@blis/trpc/react";

import { ConfirmPrompt } from "@/components/ConfirmPrompt";
import { toast } from "@/components/ui/toast";
import { useDialogProps } from "../detail/state";

export function ClearAllResultsDialog({
  accession,
}: {
  accession: { id: number };
}) {
  const dialogProps = useDialogProps("clearAll");
  const clearAll = trpc.results.clearAll.useMutation({
    onSuccess() {
      toast.success("Results cleared");
    },
    onError(err) {
      toast.error("Error clearing results", {
        description: err.message,
      });
    },
  });

  const confirmClicked = async () => {
    await clearAll.mutateAsync({ accessionId: accession.id });
    dialogProps.onOpenChange?.(false);
  };

  return (
    <ConfirmPrompt
      {...dialogProps}
      title="Clear all results"
      message="Are you sure you want to clear all results?"
      warningText="All results will be cleared. This action cannot be undone."
      onConfirm={confirmClicked}
      loading={clearAll.isPending}
      danger
    />
  );
}
